import { Component, Input } from '@angular/core';
import { Order, OrderStatus } from 'src/app/core/orders.service';
import { UtilsService } from 'src/app/core/utils.service';

@Component({
  selector: 'app-home-orders-item',
  templateUrl: './home-orders-item.component.html',
  styleUrls: ['./home-orders-item.component.scss'],
})
export class HomeOrdersItemComponent {
  @Input() order?: Order;

  constructor(private utils_service: UtilsService) {}

  getOrderStatusClass(status?: OrderStatus): string {
    if (!status) return '';
    return this.utils_service.getOrderStatusClass(status);
  }

  getOrderStatusLabel(status?: OrderStatus): string {
    return this.utils_service.getOrderStatusLabel(status);
  }
}
